import { createFileRoute } from '@tanstack/react-router';
import { CallIntelSearch } from './call-intelligence';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/call-intelligence/main')({
  staticData: { team: 'analytics' },
  validateSearch: (search: CallIntelSearch): CallIntelSearch => {
    return {
      filters: search.filters,
      openDemo: search.openDemo,
      ['submit-feedback']: search['submit-feedback'],
      subViewType: search.subViewType,
      subViewId: search.subViewId,
      tab: search.tab,
      mailer: search.mailer,
      metric: search.metric,
    };
  },
});
